var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-page-shell',{staticClass:"login-el-outer"},[_c('customer-login',{staticClass:"login-component"}),_c('vs-divider'),_c('div',{staticClass:"site-info display-flex justify-center"},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(_vm.thisYear)+" Maxain")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }